var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "kadru_addon clr" },
    [
      _c("standart", {
        attrs: { title: "Службова записка, щодо зміни штатного розпису" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "kadru_data" }, [
        _c(
          "div",
          { staticClass: "head" },
          [
            _vm._l(_vm.addon_fields, function (head) {
              return _c("div", { staticClass: "field", class: head.class }, [
                _c("div", { staticClass: "title_min" }, [
                  _vm._v(_vm._s(head.name)),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "clr" }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "before_change" },
          [
            _c("div", { staticClass: "pre_title" }, [
              _vm._v("\n                До змін\n            "),
            ]),
            _vm._v(" "),
            _c("b-form-input", {
              attrs: { placeholder: "Пiдроздiл" },
              model: {
                value: _vm.form.before_title,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "before_title", $$v)
                },
                expression: "form.before_title",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fields_insert" },
              _vm._l(_vm.rows_before, function (row, idx) {
                return _c(
                  "div",
                  { staticClass: "action_field" },
                  [
                    _vm._l(_vm.addon_fields, function (item, idx2) {
                      return _c(
                        "div",
                        { staticClass: "field_insert", class: item.class },
                        [
                          _vm.rows_before[idx][idx2].insert_val != "numb"
                            ? _c("b-form-input", {
                                model: {
                                  value: _vm.rows_before[idx][idx2].value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rows_before[idx][idx2],
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "rows_before[idx][idx2].value",
                                },
                              })
                            : _c("div", { staticClass: "np" }, [
                                _vm._v(_vm._s(idx + 1)),
                              ]),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "remove_row",
                        on: {
                          click: function ($event) {
                            return _vm.remove_row("before", idx)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "fa fa-trash active color-danger-800 cursor-pointer",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clr" }),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "add user" }, [
              _c("i", {
                staticClass:
                  "fa add_user fa-plus-square color-primary-100 cursor-pointer fs-xxl",
                attrs: { title: "" },
                on: {
                  click: function ($event) {
                    return _vm.add_row("before")
                  },
                },
              }),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "after_change" },
          [
            _c("div", { staticClass: "pre_title" }, [
              _vm._v("\n                Після змін\n            "),
            ]),
            _vm._v(" "),
            _c("b-form-input", {
              attrs: { placeholder: "Пiдроздiл" },
              model: {
                value: _vm.form.after_title,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "after_title", $$v)
                },
                expression: "form.after_title",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "add user" }, [
              _c("i", {
                staticClass:
                  "fa add_user fa-plus-square color-primary-100 cursor-pointer fs-xxl",
                attrs: { title: "" },
                on: {
                  click: function ($event) {
                    return _vm.add_row("after")
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fields_insert" },
              _vm._l(_vm.rows_after, function (row, idx) {
                return _c(
                  "div",
                  { staticClass: "action_field" },
                  [
                    _vm._l(_vm.addon_fields, function (item, idx2) {
                      return _c(
                        "div",
                        { staticClass: "field_insert", class: item.class },
                        [
                          _vm.rows_after[idx][idx2].insert_val != "numb"
                            ? _c("b-form-input", {
                                model: {
                                  value: _vm.rows_after[idx][idx2].value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rows_after[idx][idx2],
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "rows_after[idx][idx2].value",
                                },
                              })
                            : _c("div", { staticClass: "np" }, [
                                _vm._v(_vm._s(idx + 1)),
                              ]),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "remove_row",
                        on: {
                          click: function ($event) {
                            return _vm.remove_row("after", idx)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "fa fa-trash active color-danger-800 cursor-pointer",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clr" }),
                  ],
                  2
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }